var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 250.4 250",
    style: {
      enableBackground: "new 0 0 250.4 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#fff}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.672,
    y1: 14.6871,
    x2: 222.4365,
    y2: 140.7562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e15d37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1363,
    style: {
      stopColor: "#da4742"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3273,
    style: {
      stopColor: "#d32e4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5283,
    style: {
      stopColor: "#cd1d57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    style: {
      stopColor: "#ca125c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c90f5e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "m75 0 124.3 188 51.1-90.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.7386,
    y1: 245.5558,
    x2: 72.3107,
    y2: 4.9774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fcb20f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0276078,
    style: {
      stopColor: "#faab12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2744,
    style: {
      stopColor: "#e9742d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5036,
    style: {
      stopColor: "#db4842"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7081,
    style: {
      stopColor: "#d12951"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8805,
    style: {
      stopColor: "#cb165b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c90f5e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M75 0 0 51.1l28.2 171.2 72.3 27.7 90.9-73.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.1617,
    y1: 5.8492,
    x2: 180.1617,
    y2: 249.5704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#077cfb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02048671,
    style: {
      stopColor: "#1077f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    style: {
      stopColor: "#4857c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    style: {
      stopColor: "#743da1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    style: {
      stopColor: "#942b87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5141,
    style: {
      stopColor: "#a82077"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5821,
    style: {
      stopColor: "#af1c71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#a2247c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6697,
    style: {
      stopColor: "#733ea2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7394,
    style: {
      stopColor: "#4c55c2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    style: {
      stopColor: "#2e66db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    style: {
      stopColor: "#1872ed"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9398,
    style: {
      stopColor: "#0b7af7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#077cfb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "m158.6 4.3-48.7 48.5 81.5 123.3-60.6 49.3 46 24.6 73.6-42.9z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 47.5h156.2v156.2H48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.9 174.2h58.4v9.2H61.9zM158 67.9h-28.5v65h29c17.3 0 31.3-14 31.3-31.3v-1.9c-.1-17.6-14.3-31.8-31.8-31.8zm17.3 33.7c0 10.1-8.2 18.3-18.3 18.3h-13.2v-39h12.7c10.4 0 18.8 8.4 18.8 18.8v1.9zM103.3 110.2c8-3.3 13.6-11.2 13.6-20.4 0-12.2-9.9-22-22-22H62.1v65h14.2v-20.9h11.9l13.8 20.9h16.3l-15-22.6zM92.9 98.9H76.2v-18h16.7c5 0 9 4 9 9s-4 9-9 9z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRd);
export default __webpack_public_path__ + "static/media/rd.504c9dd7d5616a387566ba7603bc915e.svg";
export { ForwardRef as ReactComponent };